import { Toaster as Sonner, type ToasterProps } from "sonner"
import { Icone } from "@/components/Icone"
import { Spinner } from "@/components/ui/spinner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <Icone nome="check" className="size-4" />,
        info: <Icone nome="info" className="size-4" />,
        warning: <Icone nome="alerta" className="size-4" />,
        error: <Icone nome="alerta" className="size-4" />,
        loading: <Spinner />,
      }}
      style={
        {
          // O aviso é uma pílula escura (clara, no tema escuro), embaixo e no centro:
          // aparece onde o olho já está — a caixa de escrever, os botões — e some sozinho.
          "--normal-bg": "var(--color-tinta)",
          "--normal-text": "var(--color-fundo)",
          "--normal-border": "transparent",
          "--border-radius": "999px",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
